var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{staticClass:"mb-2",attrs:{"items":_vm.shelterList,"return-object":"","item-text":"name","hint":_vm.hint,"persistent-hint":"","value":_vm.value,"data-cy":"shelter-dropdown","label":"Select your shelter"},on:{"change":val => _vm.$store.commit('setShelter', val)}})
}
var staticRenderFns = []

export { render, staticRenderFns }